import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import CardStyles from './PassengerCard.module.css'

const PassengerCard = ({props}) => {
  const { t } = useTranslation()

  return (
    <div className={`${CardStyles.cardBlock} flex flex-row items-center justify-center gap-x-6 rounded-md`}>
      <div className="w-[50%]">
        <img src={props.img} alt="" className='w-full h-[200px] object-cover p-1 rounded-md' />
      </div>
      <div className="px-4 w-[50%] flex flex-col">
        <p className='text-lg font-bold'>{t(props.title)}</p>
        <span className='text-gray-500'>{t(props.desc)}</span>
        <Link to={props.href} className='my-6 text-green-700 hover:text-green-600'>{t("extension")}</Link>
      </div>
    </div>
  )
}

export default PassengerCard